<template lang="pug">
Message.w-full.cursor-pointer(
  v-if="hasErrors"
  severity="error" 
  @click="showErrors = true" 
  :pt="{text: {class: 'w-full'}}"
  icon="ph ph-warning-diamond"
)
  .flex-between.gap-4.w-full
    .text-lg This page has {{ format.pluralize('Error', errors.length) }}
    Button(
      label="Show Errors"
      severity="danger"
    )

  Dialog.w-full.m-20(
    v-model:visible="showErrors" 
    modal
    :dismissableMask="true"
  )
    template(#header)
      .ml-8
        .text-lg.font-bold.text-red-700 App Errors
        .text-md.font-bold.text-canvas-500.flex.gap-4
          span Current Page:
          span {{ currentUrl }}

    Accordion(:value="[0]" multiple)
      AccordionPanel(v-for="(error, idx) in errors" :key="idx" :value="idx")
        AccordionHeader
          table.table.table-md.mr-6
            tr
              td Request
              td
                .flex-between
                  .flex.gap-4
                    Tag(:value="format.toUpper(error.method)")
                    span {{ error.path }}
                  .mt-2.text-canvas-400 {{ error.fullURL }}
            tr.bg-red-700.text-white
              td Error {{error.statusCode}}
              td {{ error.title }}
        AccordionContent
          //- pre.text-md Error Details:
          pre.text-with-breaks.bg-red-50.mt-0.mr-9 {{ error.body }}

</template>

<script setup>
import { ref, computed } from 'vue'

import Dialog from 'primevue/dialog'
import Accordion from 'primevue/accordion';
import AccordionPanel from 'primevue/accordionpanel';
import AccordionHeader from 'primevue/accordionheader';
import AccordionContent from 'primevue/accordioncontent';

import { format } from '@/utils'
import { useAppErrorStore } from '@/stores'

const appErrorStore = useAppErrorStore()

const hasErrors = computed(() => appErrorStore.errors.length > 0)
const errors = computed(() => appErrorStore.errors)

const showErrors = ref(false)

const currentUrl = window.location.href

// watch(hasErrors, (val) => {
//   showErrors.value = val
// })

</script>